import Vuex from "vuex";
import Vue from "vue";
import { state } from "@/store/orai";
import { mutations } from "@/store/mutators";
import { actions } from "@/store/actions";
import { getters } from "@/store/getters";
import createPersistedState from "vuex-persistedstate";
// import SecureLS from "secure-ls";
// var ls = new SecureLS({ encodingType: '', isCompression: true });

Vue.use(Vuex);
export const persistName = "oraicachedata"
export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  // plugins: [createPersistedState({ key: persistName,
  //   storage: {
  //     getItem: key => ls.get(key),
  //     setItem: (key, value) => ls.set(key, value),
  //     removeItem: key => ls.remove(key)
  //   }
  // })],
  getters,
  mutations,
  actions
});
